import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { Link } from 'react-router'

// import components
import Header from './../../shared/components/Header'
// import Portal from './../../shared/components/Portal'
// import Confirm from './../../shared/components/Confirm'
import PunchStatsModal from '../../shared/modals/PunchStatsModal'

// import actions
import { getPunchStats, editPunchStats } from './../../actions/punchclock'
import { triggerPopup } from '../../actions/backdrop'

// import styles
import './punchclock.scss'

// Utils
import { renderFullDate } from '../../utils/time'
import { translation } from '../../utils/helpers'
import { hasSubscriptionPermission } from '../../utils/auth'

// Elements
import Button from '../../shared/elements/button'
import Label from '../../shared/elements/label'
import TableRow from '../../shared/elements/tableRow'
import Grid from '../../shared/elements/grid'
import TableContainer from '../../shared/elements/tableContainer'
import Icon from '../../shared/elements/icon'
import Inline from '../../shared/elements/inline'

import { ClockIcons } from '../../shared/elements/icons'

class PunchClock extends Component {

  constructor (props) {
    super(props)
    this.state = {
      punch: {
        IsRestrictedIp: false,
        ShowManualPunchIn: false,
        UserPunchStats: []
      },
      punchmodal: {
        open: false,
        id: 0,
        name: ''
      },
      isRequestPending: false
    }

    this.renderHeaderTitle = this.renderHeaderTitle.bind(this)
    this.renderEmployees = this.renderEmployees.bind(this)
    this.getPunchStats = this.getPunchStats.bind(this)
    this.editPunch = this.editPunch.bind(this)
  }

  componentDidMount () {
    this.getPunchStats()
  }

  getPunchStats () {
    this.props.getPunchStats().then((res) => {
      this.setState({
        punch: res.data
      })
    })
  }

  editPunch (userId, punchType) {
    const restLock = () => {
      this.setState({
        isRequestPending: false
      })
    }
    let data = {
      UserId: userId,
      PunchType: punchType
    }

    this.props.editPunchStats(data).then((res) => {
      restLock()
      if (res.data !== null) {
        this.getPunchStats()
      }
    }, restLock)
  }

  renderHeaderTitle () {
    return translation('437')
  }

  renderEmployees () {
    if (this.state.punch === undefined || this.state.punch === null) return null
    let employees = this.state.punch.UserPunchStats

    const renderEmployee = (val, key) => {
      const PUNCH_BREAK = 0
      const PUNCH_IN = 1
      const PUNCH_OUT = 2
      let userId = val.UserId
      let name = val.UserName
      let state = val.PunchType
      let lastPunchTxt = val.LastPunch
      let isPunchAllowed = val.PunchAllowed

      if (val.LastPunch === null) {
        lastPunchTxt = translation('1901') + ': ' + translation('2103')
      } else {
        if (state === PUNCH_IN) {
          lastPunchTxt = translation('1900') + ': ' + renderFullDate(val.LastPunch, true)
        } else {
          lastPunchTxt = translation('1901') + ': ' + renderFullDate(val.LastPunch, true)
        }
      }

      // const doPunchBreak = () => {
      //   this.editPunch(userId, PUNCH_BREAK)
      // }
      const doPunchIn = () => {
        this.setState({
          isRequestPending: true
        }, () => this.editPunch(userId, PUNCH_IN))
      }

      const doPunchOut = () => {
        this.editPunch(userId, PUNCH_OUT)
      }

      let stateTxt = ''
      switch (state) {
        case PUNCH_BREAK:
          stateTxt = translation('13561')
          break
        case PUNCH_IN:
          stateTxt = translation('441')
          break
        case PUNCH_OUT:
          stateTxt = translation('1899')
          break
      }
      let bgClass = (state === PUNCH_IN) ? 'selected' : ''

      // ShowIn / ShowOut
      let showIn = true
      let showOut = true

      if (!this.state.punch.ShowManualPunchIn) {
        showIn = false
      }

      if (this.state.punch.IsRestrictedIp) {
        showIn = false
        showOut = false
      }

      const openPunchStats = (e) => {
        e.preventDefault()
        this.props.triggerPopup(true)
        this.setState({
          punchmodal: {
            open: true,
            id: userId,
            name: name
          }
        })
      }

      return (
        <div className={bgClass} key={'empl_' + key}>
          <Grid cols={''} align='center' className='list__item'>
            <div>
              <a href='' onClick={openPunchStats}>{name} ({val.UserInitials})</a>
              <div>{lastPunchTxt}</div>
            </div>
            <Inline>
              <Label>{translation(2230)}:</Label>
              <Label>{stateTxt}</Label>
            </Inline>
            {state === PUNCH_IN && showOut && (
              <Button style='alert' spacing={0} labelText={(<Icon icon={ClockIcons.Punch_Out_Red} />)} onClick={doPunchOut} disabled={!isPunchAllowed} />
            )}
            {state === PUNCH_OUT && showIn && (
              <Button style='link' spacing={0} labelText={(<Icon icon={ClockIcons.Punch_In} />)} onClick={doPunchIn} disabled={this.state.isRequestPending || !isPunchAllowed} />
            )}
          </Grid>
        </div>
      )
    }
    return (
      <div className='employee__list'>
        <TableContainer>
          <TableRow cols={['auto', '236px']} header>
            <Label>{translation(450)}</Label>
            <Label>{translation(2230)}</Label>
          </TableRow>
          {employees.map(renderEmployee)}
        </TableContainer>
      </div>
    )
  }

  closePunchModal () {
    this.props.triggerPopup(false)
    this.setState({
      punchmodal: {
        open: false,
        id: 0,
        name: ''
      }
    })
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    return (
      <div className='punchclock__screen'>
        <Header router={this.props.router} />
        <div>
          {this.renderEmployees()}
        </div>
        {this.state.punchmodal.open && (
          <PunchStatsModal
            show={this.state.punchmodal.open}
            id={this.state.punchmodal.id}
            name={this.state.punchmodal.name}
            onClose={this.closePunchModal.bind(this)} />
        )}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    employees: state.common.employees
  }
}

export default connect(mapStateToProps, {
  getPunchStats,
  editPunchStats,
  renderFullDate,
  triggerPopup
})(PunchClock)



// WEBPACK FOOTER //
// ./src/app/pages/PunchClock/index.js